import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "social-login" }
const _hoisted_2 = { class: "flex items-center justify-center gap-x-6" }

import AppleLogin from "@/components/SocialLogins/AppleLogin.vue";
import GoogleLogin from "@/components/SocialLogins/GoogleLogin.vue";
import FacebookLogin from "@/components/SocialLogins/FacebookLogin.vue";
import { store } from "@/state/store";
import { isIOSVersionAtMost, isInAppBrowserWithLimitedTabs, isIOS } from "@/services/utils";
import { $t } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialLogin',
  setup(__props) {

const isAppleLoginActive = () => {
	if (!window.ocm.config.isAppleLoginActive) {
		return false;
	}

	const isAtMostIOS17_1 = isIOSVersionAtMost({ major: 17, minor: 1, patch: 0 });

	if (isIOS() && !isAtMostIOS17_1 && isInAppBrowserWithLimitedTabs()) {
		return false;
	}

	if (!isIOS() && isInAppBrowserWithLimitedTabs()) {
		return false;
	}

	return true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(store).isLandingPage ? 'h2' : 'h3'), { class: "line-on-side mb-4 text-center text-base leading-5 text-gray-80" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(store).isLogin ? _unref($t)("login.social_headline") : _unref($t)("registration.social_headline")), 1)
      ]),
      _: 1
    })),
    _createElementVNode("div", _hoisted_2, [
      (isAppleLoginActive())
        ? (_openBlock(), _createBlock(AppleLogin, { key: 0 }))
        : _createCommentVNode("", true),
      (!_unref(isInAppBrowserWithLimitedTabs)())
        ? (_openBlock(), _createBlock(GoogleLogin, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(FacebookLogin)
    ])
  ]))
}
}

})